module.exports = __webpack_public_path__ + "bc35f7b5e37f4962d34597b08844527c.pdf";